import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Dialog, DialogType, Label, TextField } from '@fluentui/react';

import { useState, useCallback } from 'react';
import { history } from '../../redux/store';
import { ROUTES } from '../../config/routes';

export class GoToVisitDialog {
  public static show() {
    const dialogNode = document.createElement('div');
    const close = () => {
      ReactDOM.unmountComponentAtNode(dialogNode);
      dialogNode.remove();
    };
    ReactDOM.render(<Internal close={close} />, dialogNode);
  }
}

const Internal = ({ close }: { close: () => void }) => {
  const [code, setCode] = useState('');

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<any>) => {
      if (e.key === 'Enter' && code) {
        let visitCode = code.toUpperCase();
        const index = code.indexOf('-');
        if (index === -1) {
          visitCode = code.substr(0, 2) + '-' + code.substr(2);
        }
        history.push(`${ROUTES.visits}/${visitCode}`);
        close();
      }
    },
    [code, close]
  );

  const onChange = useCallback((ev: React.FormEvent, value?: string) => {
    if (!value) {
      setCode('');
      return;
    }
    setCode(value.toUpperCase());
  }, []);

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        type: DialogType.largeHeader,
        title: 'Go to Visit...',
      }}
      onDismiss={close}
    >
      <Label>Code (Press Enter to go...)</Label>
      <TextField onChange={onChange} onKeyDown={onKeyDown} value={code} validateOnFocusOut={true} />
    </Dialog>
  );
};
